import TestDataPage from './TestDataPage';

export { TestDataPage };
export default TestDataPage; 